import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../shared/Navbar";
import useWindowSize from "../../hooks/useWindow";
import * as urlHelp from "../../features/urlHelpers";
import {
  DataGridPremium,
  csCZ,
  GridColumns,
  useGridApiRef,
  GridRowsProp,
  GridToolbarExport,
  GridToolbarContainer,
} from "@mui/x-data-grid-premium";
import { LicenseInfo } from "@mui/x-data-grid-premium";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useHistory } from "react-router-dom";
import Stack from "@mui/material/Stack";
import { useSelector, useDispatch } from "react-redux";
//import { RootState } from "../../redux/store";
import Moment from "moment";
import { getLicense } from "../shared/license";
import { getRowStatus_isCorrect } from "../shared/search";
//import { logoutUser } from "../../redux/actions/authActions";
import { logout, log_or_not } from "../shared/authFunctions";
import axios from "axios";
import { loginData } from "../auth/redux/loginSlice";
import { errorHandleDialog } from "../shared/errorDialog";
import remove_accents from "remove-accents";
import styles from "./ZpeTable.module.sass";

function ZpeTable() {
  //const [ztpData, setZtpData] = useState([] as GridRowsProp); //data do tabulky ziskane z backendu
  const [rows, setRows] = useState([] as GridRowsProp);
  const [rows_loaded, setRowsLoaded] = useState(false as boolean);
  const [usek, setUsek] = useState("Vše");
  const [searchValue, setSearchedValue] = useState("");
  const { width } = useWindowSize();
  const apiRef = useGridApiRef();
  const navigate = useHistory();
  //const logindata = useSelector((state: RootState) => state.login);
  //const zdata = useSelector((state: RootState) => state.ztp);
  const logindata = useSelector(loginData);
  const [date, setDate] = useState("");
  const dispatch = useDispatch();
  LicenseInfo.setLicenseKey(getLicense());

  async function getZpeData() {
    await axios
      .get(
        urlHelp.zpeUrl + "?datum_vyroba=" + urlHelp.get_datum_vyroba(logindata),
        urlHelp.get_header(logindata)
      )
      .then(function (response) {
        let i = 0;
        console.log("zpedata", response.data.data);
        let sum_pozn = "";
        const newData = response.data.data.reverse().map((obj: any) => {
          if (obj.typr === 1) {
            sum_pozn = obj.pecivo;
          }
          return {
            ...obj,
            id: i++,
            sum_help: obj.typr === 0 ? sum_pozn : "",
          };
        });

        //console.log(newData.reverse())

        //setZtpData(newData);
        setRows(newData.reverse());
        setDate(urlHelp.get_datum_vyroba(logindata).slice(0, 10));
        setRowsLoaded(true);
      })
      .catch(function (error) {
        errorHandleDialog(error.response, navigate, dispatch);
      });
  }

  useEffect(() => {
    log_or_not(logindata, navigate, dispatch);
    setRowsLoaded(false);
    getZpeData();
  }, []);

  const styleTable = {
    height: window.innerHeight - 210.8,
    width: "100%",
    margin: 0,
    "& .MuiDataGrid-cell--editable": {
      backgroundColor: "rgb(240,255,240)",
      "&:hover": {
        backgroundColor: "rgb(240,255,0)",
      },
    },
    "& .super-app-theme--1": {
      backgroundColor: "rgba(0,102,0,255)",
      color: "rgb(255, 255, 255)",
      "&:hover": {
        backgroundColor: "rgba(0,102,0,255)",
      },
    },
    "& .super-app-theme--2": {
      backgroundColor: "rgb(73, 69, 41)",
      color: "rgb(255, 255, 255)",
      "&:hover": {
        backgroundColor: "rgba(0,102,0,255)",
      },
    },
  };

  function CustomToolbar() {
    return (
      <div>
        <GridToolbarContainer>
          <div className={styles.GridToolbar}>
            <div>
              <GridToolbarExport
                printOptions={{
                  hideFooter: true,
                }}
                csvOptions={{
                  delimiter: ";",
                  utf8WithBom: true,
                  fileName: "ZPE",
                }}
              />
            </div>
            <div>Úsek: {usek}</div>
            <div>Výroba: {Moment(date).format("DD.MM.YYYY")} ZPE</div>
          </div>
        </GridToolbarContainer>
      </div>
    );
  }
  function CustomToolbarEmpty() {
    return <div></div>;
  }

  function filter(data: any) {
    let newData = data
      .filter(
        (row: any) =>
          String(
            remove_accents(row.znacka_sur ? row.znacka_sur.toUpperCase() : "")
          ).includes(remove_accents(searchValue.toUpperCase())) ||
          String(
            remove_accents(row.nazov_sur ? row.nazov_sur.toUpperCase() : "")
          ).includes(remove_accents(searchValue.toUpperCase())) ||
          row.typr === 2 ||
          row.typr === 1
      )
      .filter((row: any) => {
        if (
          usek === "Vše" ||
          usek === row.usek ||
          row.typr === 2 ||
          row.typr === 1
        ) {
          return true;
        } else {
          return false;
        }
      });
    //riesenie zobrazenia riadka typu 1 po filtraci
    const helpData = newData.filter((row: any) => {
      if (
        row.typr === 1 &&
        newData.filter((row_: any) => row_.sum_help === row.pecivo).length === 0
      ) {
        return false;
      } else {
        return true;
      }
    });
    //riesenie zobrazenia riadka typu 2 po filtraci
    return helpData.filter((row: any) => {
      if (row.typr === 2 && helpData.length <= 1) {
        return false;
      } else {
        return true;
      }
    });
  }

  const columns: GridColumns = [
    {
      field: "pecivo",
      headerName: "Pečivo",
      editable: false,
      width: 180,
      pinnable: false,
      sortable: false,
      headerAlign: "center",
    },
    {
      field: "poradie",
      headerName: "Pořadí",
      type: "number",
      editable: false,
      width: 75,
      pinnable: false,
      sortable: false,
      headerAlign: "center",
    },
    {
      field: "znacka_sur",
      headerName: "Kod suroviny",
      editable: false,
      width: 120,
      pinnable: false,
      sortable: false,
      headerAlign: "center",
    },
    {
      field: "nazov_sur",
      headerName: " Název suroviny",
      editable: false,
      width: 240,
      pinnable: false,
      sortable: false,
      headerAlign: "center",
    },

    {
      field: "mj",
      headerName: "MJ",
      width: 60,
      type: "number",
      editable: false,
      pinnable: false,
      sortable: false,
      headerAlign: "center",
    },
    {
      field: "avg_prokroj",
      headerName: "Ø Prokroj",
      width: 140,
      type: "number",
      editable: false,
      pinnable: false,
      sortable: false,
      renderCell: (params: any) => {
        let valueFormatted = Number(params.value as number);

        let sum = 0;
        let medzi_sum = 0;

        if (params.row.typr === 2) {
          filter(rows).map((row: any) => {
            if (row.typr !== 2 && row.typr !== 1) {
              sum += row.avg_prokroj;
            }
          });
          valueFormatted =
            sum / filter(rows).filter((row: any) => row.typr === 0).length;
        }

        if (params.row.typr === 1) {
          filter(rows)
            .filter((row_: any) => row_.sum_help === params.row.pecivo)
            .map((row: any) => {
              medzi_sum += row.avg_prokroj;
            });

          valueFormatted =
            medzi_sum /
            filter(rows).filter(
              (row_: any) => row_.sum_help === params.row.pecivo
            ).length;
        }

        const value = valueFormatted
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$& ");

        return <div className={styles.cell}>{`${value} %`}</div>;
      },
      headerAlign: "center",
    },
    {
      field: "sum_surovina",
      headerName: "∑ Surovina",
      width: 140,
      type: "number",
      editable: false,
      pinnable: false,
      sortable: false,
      renderCell: (params: any) => {
        let valueFormatted = Number(params.value as number);

        let sum = 0;
        let medzi_sum = 0;

        if (params.row.typr === 2) {
          filter(rows).map((row: any) => {
            if (row.typr !== 2 && row.typr !== 1) {
              sum += row.sum_surovina;
            }
          });
          valueFormatted = sum;
        }

        if (params.row.typr === 1) {
          filter(rows)
            .filter((row_: any) => row_.sum_help === params.row.pecivo)
            .map((row: any) => {
              medzi_sum += row.sum_surovina;
            });

          valueFormatted = medzi_sum;
        }

        const value = valueFormatted
          .toFixed(1)
          .replace(/\d(?=(\d{3})+\.)/g, "$& ");

        return <div className={styles.cell}>{`${value}`}</div>;
      },
      headerAlign: "center",
    },
    {
      field: "sum_pekarna",
      headerName: "∑ Pekárna",
      width: 140,
      type: "number",
      editable: false,
      pinnable: false,
      sortable: false,
      renderCell: (params: any) => {
        let valueFormatted = Number(params.value as number);

        let sum = 0;
        let medzi_sum = 0;

        if (params.row.typr === 2) {
          filter(rows).map((row: any) => {
            if (row.typr !== 2 && row.typr !== 1) {
              sum += row.sum_pekarna;
            }
          });
          valueFormatted = sum;
        }

        if (params.row.typr === 1) {
          filter(rows)
            .filter((row_: any) => row_.sum_help === params.row.pecivo)
            .map((row: any) => {
              medzi_sum += row.sum_pekarna;
            });

          valueFormatted = medzi_sum;
        }

        const value = valueFormatted
          .toFixed(1)
          .replace(/\d(?=(\d{3})+\.)/g, "$& ");

        return <div className={styles.cell}>{`${value}`}</div>;
      },
      headerAlign: "center",
    },
    {
      field: "sum_bochnik",
      headerName: "∑ Bochníky",
      width: 140,
      type: "number",
      editable: false,
      pinnable: false,
      sortable: false,
      renderCell: (params: any) => {
        let valueFormatted = Number(params.value as number);

        let sum = 0;
        let medzi_sum = 0;

        if (params.row.typr === 2) {
          filter(rows).map((row: any) => {
            if (row.typr !== 2 && row.typr !== 1) {
              sum += row.sum_bochnik;
            }
          });
          valueFormatted = sum;
        }

        if (params.row.typr === 1) {
          filter(rows)
            .filter((row_: any) => row_.sum_help === params.row.pecivo)
            .map((row: any) => {
              medzi_sum += row.sum_bochnik;
            });

          valueFormatted = medzi_sum;
        }

        const value = valueFormatted
          .toFixed(1)
          .replace(/\d(?=(\d{3})+\.)/g, "$& ");

        return <div className={styles.cell}>{`${value}`}</div>;
      },
      headerAlign: "center",
    },
    {
      field: "min_vykon",
      headerName: "min Výkon",
      width: 140,
      type: "number",
      editable: false,
      pinnable: false,
      sortable: false,
      renderCell: (params: any) => {
        let valueFormatted = Number(params.value as number);

        let sum = 0;
        let medzi_sum = 0;

        if (params.row.typr === 2) {
          filter(rows).map((row: any) => {
            if (row.typr !== 2 && row.typr !== 1) {
              sum += row.min_vykon;
            }
          });
          valueFormatted = sum;
        }

        if (params.row.typr === 1) {
          filter(rows)
            .filter((row_: any) => row_.sum_help === params.row.pecivo)
            .map((row: any) => {
              medzi_sum += row.min_vykon;
            });

          valueFormatted = medzi_sum;
        }

        const value = valueFormatted
          .toFixed(1)
          .replace(/\d(?=(\d{3})+\.)/g, "$& ");

        return <div className={styles.cell}>{`${value}`}</div>;
      },
      headerAlign: "center",
    },
    {
      field: "sum_cas",
      headerName: "∑ Čas",
      width: 140,
      type: "number",
      editable: false,
      pinnable: false,
      sortable: false,
      renderCell: (params: any) => {
        let valueFormatted = Number(params.value as number);

        let sum = 0;
        let medzi_sum = 0;

        if (params.row.typr === 2) {
          filter(rows).map((row: any) => {
            if (row.typr !== 2 && row.typr !== 1) {
              sum += row.sum_cas;
            }
          });
          valueFormatted = sum;
        }

        if (params.row.typr === 1) {
          filter(rows)
            .filter((row_: any) => row_.sum_help === params.row.pecivo)
            .map((row: any) => {
              medzi_sum += row.sum_cas;
            });

          valueFormatted = medzi_sum;
        }

        let strin_minutes;
        let strin_hours;
        var minutes = valueFormatted % 60;
        var hours = (valueFormatted - minutes) / 60;
        if (minutes.toString().length === 1) {
          strin_minutes = "0" + minutes;
        } else {
          strin_minutes = minutes;
        }

        if (hours.toString().length === 1) {
          strin_hours = "0" + hours;
        } else {
          strin_hours = hours;
        }

        var output = strin_hours + ":" + strin_minutes;

        return <div className={styles.cell}>{`${output}`}</div>;
      },
      headerAlign: "center",
    },
  ];

  return (
    <div>
      <Navbar />
      <div
        style={{
          height: window.innerHeight - 70.8,
        }}
      >
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.selectArea}>
              <div>Úsek: </div>
              <div>
                <select
                  className={styles.select}
                  value={usek}
                  onChange={(e) => setUsek(e.target.value)}
                >
                  <option selected value="Vše">
                    Vše
                  </option>
                  <option value="Kompletace">Kompletace</option>
                  <option value="Pekárna">Pekárna</option>
                  <option value="ZTP">ZTP</option>
                </select>
              </div>
            </div>

            <input
              onChange={(e) => {
                setSearchedValue(e.target.value);
              }}
              className={styles.input}
              placeholder="Hledej"
            ></input>
            <div className={styles.title}>ZPE</div>
          </div>
          <div className={styles.grid}>
            {rows_loaded ? (
              <DataGridPremium
                sx={styleTable}
                disableColumnMenu={true}
                components={{
                  Toolbar:
                    rows.length === 1 ? CustomToolbarEmpty : CustomToolbar,
                }}
                localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
                apiRef={apiRef}
                hideFooter
                rows={filter(rows)}
                columns={columns}
                rowHeight={25}
                getRowClassName={(params: any) =>
                  `super-app-theme--${params.row.typr}`
                }
                disableSelectionOnClick
                disableColumnReorder
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default ZpeTable;
